const WebsocketConstants = {
  RENTAL_MANAGER_WS_URL: 'wss://www.zillow.com/rental-manager-api/ws/services',
};

export default WebsocketConstants;
